module.exports = __webpack_public_path__ + "img/va.8855777b.svg";